import { ProgramCategoryFilterRow } from 'components/eventView/filters/ProgramCategoryFilterRow';
import { ProgramDayFilterRow } from 'components/eventView/filters/ProgramDayFilterRow';
import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EventViewProgramPageContent } from 'components/eventView/pages/EVProgramPageContent';
import { SearchInput } from 'elements/eventView/atomic/SearchInput';
import { StickyHeaderContentLayout } from 'elements/eventView/layout/StickyHeaderContentLayout';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { EVDetailListPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVDetailListPageMobile';
import { EVDetailPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVDetailPageMobile';
import { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVProgramPageMobile = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);

    return (
        <S_EVProgramPageMobile className={props.className}>
            <StickyHeaderLayout>
                <PageHeaderMini>
                    {ctxEventView.eventData?.programSettings?.searchable ? (
                        <SearchInput
                            value={ctxEventView.programSearchTerm}
                            placeholder={ctxEventView.programTitleShort}
                            onChange={(value) => {
                                ctxEventView.setProgramSearchTerm(value);
                            }}
                            clearButton
                        />
                    ) : (
                        <>{ctxEventView.programTitleShort}</>
                    )}
                </PageHeaderMini>
            </StickyHeaderLayout>
            <StickyHeaderContentLayout headerHeight={64}>
                <S_ProgramDayFilterRow />
                <ProgramCategoryFilterRow isWide={false} />
                <S_EventViewProgramPageContent />
            </StickyHeaderContentLayout>
            <Routes location={location} key={location.pathname}>
                <Route
                    path="list/:entityId"
                    element={<EVDetailListPageMobile entity="program" />}
                />
                <Route path=":detailId" element={<S_EVDetailPageMobile />} />
            </Routes>
        </S_EVProgramPageMobile>
    );
};

const S_EVProgramPageMobile = styled(motion.div)``;

const S_ProgramDayFilterRow = styled(ProgramDayFilterRow)`
    border-bottom: 1px solid #d9d9d9;
`;

const S_EVDetailPageMobile = styled(EVDetailPageMobile)`
    position: relative;
    z-index: 4;
`;

const S_EventViewProgramPageContent = styled(EventViewProgramPageContent)`
    padding: 20px 5px 200px 5px;
`;
